import { Dispatch, SetStateAction } from "react";

export const handleIndicatorFilter = (
  dispatch: Dispatch<any>,
  setStatusBionexo: Dispatch<SetStateAction<string[]>>,
  setStatusViveo: Dispatch<SetStateAction<string[]>>,
  setOrderStatus: Dispatch<SetStateAction<string[]>>,
  setQuoteCategory: Dispatch<SetStateAction<string[]>>,
  getBionexoQuote: (
    filterTextQuote?: string, 
    statusBionexoQuote?: string[], 
    statusViveoQuote?: string[], 
    quoteCategory?: string[], 
    resetCurrentPage?: boolean, 
    sentExpiredFilter?: boolean
  ) => Promise<void>,
  getPreOrder: (
    orderSearchText?: string, 
    status?: string[], 
    categories?: string[], 
    resetCurrentPage?: boolean
  ) => Promise<void>,
  setSelectedRadio: Dispatch<SetStateAction<number>>,
  setOrderRadioSelected: Dispatch<React.SetStateAction<boolean>>,
  title?: string,
  ) => {
  switch (title) {
    case 'ABERTAS':
      setSelectedRadio(0);
      setOrderRadioSelected(false);
      setStatusBionexo(["OPEN"]);
      setStatusViveo(["VALIDATE_PORTAL"]);
      setQuoteCategory([]);

      dispatch({
        type: "SET_STATUS_BIONEXO",
        statusBionexo: ["OPEN"]
      });
      dispatch({
        type: "SET_STATUS_VIVEO",
        statusViveo: ["VALIDATE_PORTAL"]
      });
      dispatch({
        type: "SET_QUOTE_CATEGORIES",
        quoteCategory: []
      });

      getBionexoQuote("", ["0"], ["0"], [], true);
      break;

    case 'ENVIADAS':
      setSelectedRadio(0);
      setOrderRadioSelected(false);
      setStatusBionexo(["OPEN", "CANCELED", "SENT", "CLOSED", "PROCESSING", "UPDATED"]);
      setStatusViveo([
        "ANSWERED_MONEY", 
        "ANSWERED_PORTAL_MONEY", 
        "ANSWERED_PORTAL", 
        "ANSWERED_BIONEXO", 
        "PENDING_MONEY", 
        "QUEUE_BIONEXO", 
        "QUEUE_MONEY"
      ]);
      setQuoteCategory([]);

      dispatch({
        type: "SET_STATUS_BIONEXO",
        statusBionexo: ["OPEN", "CANCELED", "SENT", "CLOSED", "PROCESSING", "UPDATED"]
      });
      dispatch({
        type: "SET_STATUS_VIVEO",
        statusViveo: [
          "ANSWERED_MONEY", 
          "ANSWERED_PORTAL_MONEY", 
          "ANSWERED_PORTAL", 
          "ANSWERED_BIONEXO", 
          "PENDING_MONEY", 
          "QUEUE_BIONEXO", 
          "QUEUE_MONEY"
        ]
      });
      dispatch({
        type: "SET_QUOTE_CATEGORIES",
        quoteCategory: []
      });

      getBionexoQuote(
        "", 
        ["0", "1", "2", "3", "4", "6", "8"], 
        ["1", "2", "3", "5", "6", "11", "13"], 
        [], 
        true
      );
      break;

    case 'PENDENTE MONEY':
      setSelectedRadio(0);
      setOrderRadioSelected(false);
      setStatusBionexo(["SENT", "OPEN", "CLOSED", "UPDATED"]);
      setStatusViveo(["PENDING_MONEY"]);
      setQuoteCategory([]);

      dispatch({
        type: "SET_STATUS_BIONEXO",
        statusBionexo: ["SENT", "OPEN", "CLOSED", "UPDATED"]
      });
      dispatch({
        type: "SET_STATUS_VIVEO",
        statusViveo: ["PENDING_MONEY"]
      });
      dispatch({
        type: "SET_QUOTE_CATEGORIES",
        quoteCategory: []
      });

      getBionexoQuote("", ["4", "0", "2", "8"], ["1"], [], true);
      break;

    case 'PEDIDOS':
      setSelectedRadio(1);
      setOrderRadioSelected(true);
      setStatusBionexo([]);
      setStatusViveo([]);
      setQuoteCategory([]);
      setOrderStatus(["CONFIRMED", "CANCELED"]);

      dispatch({
        type: "SET_STATUS_BIONEXO",
        statusBionexo: []
      });
      dispatch({
        type: "SET_STATUS_VIVEO",
        statusViveo: []
      });
      dispatch({
        type: "SET_QUOTE_CATEGORIES",
        quoteCategory: []
      });
      dispatch({
        type: "SET_ORDER_STATUS",
        orderStatus: ["CONFIRMED", "CANCELED"]
      })

      getPreOrder("", ["CONFIRMED", "CANCELED"]);
      break;

    case 'ENVIADAS/EXPIRADAS':
      setSelectedRadio(0);
      setOrderRadioSelected(false);
      setStatusBionexo(["OPEN", "CANCELED", "SENT", "CLOSED", "PROCESSING", "UPDATED"]);
      setStatusViveo([
        "ANSWERED_MONEY", 
        "ANSWERED_PORTAL_MONEY", 
        "ANSWERED_PORTAL", 
        "ANSWERED_BIONEXO", 
        "PENDING_MONEY", 
        "QUEUE_BIONEXO", 
        "QUEUE_MONEY"
      ]);
      setQuoteCategory([]);

      dispatch({
        type: "SET_STATUS_BIONEXO",
        statusBionexo: ["OPEN", "CANCELED", "SENT", "CLOSED", "PROCESSING", "UPDATED"]
      });
      dispatch({
        type: "SET_STATUS_VIVEO",
        statusViveo: [
          "ANSWERED_MONEY", 
          "ANSWERED_PORTAL_MONEY", 
          "ANSWERED_PORTAL", 
          "ANSWERED_BIONEXO", 
          "PENDING_MONEY", 
          "QUEUE_BIONEXO", 
          "QUEUE_MONEY"
        ]
      });
      dispatch({
        type: "SET_QUOTE_CATEGORIES",
        quoteCategory: []
      });

      dispatch({
        type: "SET_SENT_EXPIRED_FILTER",
        sentExpiredFilter: true,
      });
      
      getBionexoQuote(
        "", 
        ["0", "1", "2", "3", "4", "6", "8"], 
        ["1", "2", "3", "5", "6", "11", "13"], 
        [], 
        true, 
        true
      );
      break;
  
    case 'EXPIRADAS':
      setSelectedRadio(0);
      setOrderRadioSelected(false);
      setStatusBionexo(["CLOSED"]);
      setStatusViveo(["EXPIRED"]);
      setQuoteCategory([]);

      dispatch({
        type: "SET_STATUS_BIONEXO",
        statusBionexo: ["CLOSED"]
      });
      dispatch({
        type: "SET_STATUS_VIVEO",
        statusViveo: ["EXPIRED"]
      });
      dispatch({
        type: "SET_QUOTE_CATEGORIES",
        quoteCategory: []
      });

      getBionexoQuote("", ["2"], ["7"], [], true);
      break;
  }
};